import React, { PropsWithChildren } from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { StyleEnums } from "models/enums";
import { AutogeneratedMessageProps } from "models/propTypes/messagePropTypes";
//#endregion
//#region components
import SimpleMessage from "./simpleMessage";
//#endregion

const AutoGeneratedMessage: React.FC<PropsWithChildren<AutogeneratedMessageProps>> = (props) => {
  return (
    <SimpleMessage
      icon={IconDefinitionConstants.WBolt}
      displayType={StyleEnums.DisplayType.Warning}
      className={props.className}
    >
      {props.children}
    </SimpleMessage>
  );
};

export default AutoGeneratedMessage;
